import React from 'react';
import Wareeg from "../assets/wareeg.svg";

const Logo = () => {
  return (
    <img src={Wareeg} alt='wareeg Logo' />
  )
}

export default Logo